﻿import { ConfirmationModal } from 'pages/students/pages/merge/components/ConfirmationModal';
import { FindStudentModal } from 'pages/students/pages/merge/components/FindStudentModal';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { helpContent } from 'pages/students/pages/merge/help';
import { FormattedMessage, useIntl } from 'react-intl';
import { PageHeader } from 'components/layout/page';
import { DefaultLayout } from 'components/layout';
import { Card, Col, Row } from 'react-bootstrap';
import { KendoIntlProvider } from 'app/culture';
import { useSuperState } from 'hooks';
import { Student } from 'types';

export const MergeStudents = () => {

    const { formatMessage, locale } = useIntl();
    const [state, setState] = useSuperState({
        keepAccount: undefined as Student | undefined,
        keepSearch: true,
        mergeAccount: undefined as Student | undefined,
        showConfirmationModal: false,
        showFindStudentModal: false
    });

    const { keepAccount } = state;

    const openKeepModal = () => {

        setState({ keepSearch: true, showFindStudentModal: true });

    };

    const openMergeModal = () => {

        setState({ keepSearch: false, showFindStudentModal: true });

    };

    const mergeAccounts = () => {

        //Logic to Merge accounts
    };

    const openConfirmationModal = () => {

        if (state.keepAccount && state.mergeAccount) {

            setState({ showConfirmationModal: true });

        }

    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'merge_students.8704ea51', defaultMessage: 'Merge Students' })}>
            <KendoIntlProvider>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <div className={'merge-students'}>
                            <FindStudentModal
                                keep={state.keepSearch}
                                setKeepAccount={keepAccount => setState({ keepAccount })}
                                setMergeAccount={mergeAccount => setState({ mergeAccount })}
                                setShow={show => setState({ showFindStudentModal: show })}
                                show={state.showFindStudentModal}
                            />

                            {
                                state.keepAccount && state.mergeAccount && (
                                    <ConfirmationModal
                                        keepAccount={state.keepAccount}
                                        mergeAccount={state.mergeAccount}
                                        setShow={show => setState({ showConfirmationModal: show })}
                                        show={state.showConfirmationModal}
                                    />
                                )}

                            <PageHeader helpContent={helpContent} title={formatMessage({ id: 'merge_students.8704ea51', defaultMessage: 'Merge Students' })} />

                            <Row className={'gy-3'}>
                                <Col md={6} xs={12}>
                                    <Card>
                                        <Card.Header as="h5">
                                            <FormattedMessage defaultMessage="Account to Keep" id="account_to_keep.980b996d" />
                                        </Card.Header>
                                        <Card.Body>
                                            {keepAccount ?
                                                (
                                                    <>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Name" id="name.5458f379" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {keepAccount.FirstName + ' ' + keepAccount.LastName}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Username" id="username.dceab582" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {keepAccount.UserName}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Email" description="Formulario" id="email.5cbb5845" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {keepAccount.EmailAddress}
                                                        </Card.Text>
                                                    </>
                                                )
                                                :
                                                (
                                                    <Card.Text>
                                                        <FormattedMessage defaultMessage="Select the account you would like to keep." id="select_the_account_you_would_like_to_kee.1dac1d4c" />
                                                    </Card.Text>
                                                )
                                            }
                                            <GMetrixButton onClick={openKeepModal} variant="outline-primary" >
                                                <FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />
                                            </GMetrixButton>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={6} xs={12}>
                                    <Card>
                                        <Card.Header as="h5">
                                            <FormattedMessage defaultMessage="Account to Merge" id="account_to_merge.20112764" />
                                        </Card.Header>
                                        <Card.Body>
                                            {state.mergeAccount ?
                                                (
                                                    <>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Name" id="name.5458f379" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {state.mergeAccount.FirstName + ' ' + state.mergeAccount.LastName}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Username" id="username.dceab582" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {state.mergeAccount.UserName}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <b>
                                                                <FormattedMessage defaultMessage="Email" description="Formulario" id="email.5cbb5845" />
                                                                :
                                                            </b>
                                                            {' '}
                                                            {state.mergeAccount.EmailAddress}
                                                        </Card.Text>
                                                    </>
                                                )
                                                :
                                                (
                                                    <Card.Text>
                                                        <FormattedMessage defaultMessage="Select the account you would like to merge." id="select_the_account_you_would_like_to_mer.24df8af5" />
                                                    </Card.Text>
                                                )
                                            }
                                            <GMetrixButton onClick={openMergeModal} variant="outline-primary">
                                                <FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />
                                            </GMetrixButton>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <GMetrixButton
                                style={{
                                    display: 'block',
                                    margin: '0 auto',
                                    marginTop: 25
                                }}
                                disabled={!state.keepAccount && !state.mergeAccount}
                                onClick={() => openConfirmationModal()}
                                variant="primary"
                            >

                                <FormattedMessage defaultMessage="Merge Accounts" id="merge_accounts.c9f71fb8" />
                            </GMetrixButton>

                        </div>
                    </IntlProvider>
                </LocalizationProvider>
            </KendoIntlProvider>
        </DefaultLayout>
    );

};